export default {"src":"/_next/static/image/public/assets/sos.8a0326a18345b751e624651a008576fe.svg","height":30,"width":30};